/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

/**
 * Navigation menu configuration.
 *
 * Project-scoped items (sessions, participants, etc.) will automatically have their
 * links updated to /projects/{projectId}/* when a project is selected via the NavigationService.
 */
export const defaultNavigation: FuseNavigationItem[] = [
  {
    id: 'projects',
    title: 'Projects',
    type: 'basic',
    icon: 'heroicons_outline:squares-2x2',
    link: '/projects',
    exactMatch: true,
  },
  {
    id: 'divider-1',
    type: 'divider',
  },
  {
    id: 'project-settings',
    title: 'Manage',
    type: 'basic',
    icon: 'heroicons_outline:adjustments-horizontal',
    link: '/settings',
  },
  {
    id: 'voice',
    title: 'Voice',
    type: 'basic',
    icon: 'odin-voice',
    link: '/voice',
  },
  {
    id: 'fleet',
    title: 'Fleet',
    type: 'basic',
    icon: 'odin-fleet',
    link: '/fleet',
  },
  {
    id: 'cortex',
    title: 'Cortex',
    type: 'basic',
    icon: 'odin-cortex',
    link: '/cortex',
  },
  {
    id: 'rooms',
    title: 'Rooms',
    type: 'basic',
    icon: 'odin-rooms',
    link: '/rooms',
  },
];
export const compactNavigation: FuseNavigationItem[] = defaultNavigation;
export const futuristicNavigation: FuseNavigationItem[] = defaultNavigation;
export const horizontalNavigation: FuseNavigationItem[] = defaultNavigation;
